export default __webpack_public_path__ + "static/media/puppeteer.b77eae16.svg";